'use client';

import { createContext, useContext } from 'react';
import { FunctionHelpers } from '@headless-workspace/utils';
import { EngraveFormReturnType } from '../../../../../src';

export type EngraveContextValueType = {
    engraveFormValues?: EngraveFormReturnType;
    setEngraveFormValues: (values?: EngraveFormReturnType) => void;
};

const engraveContextInitialState: EngraveContextValueType = {
    engraveFormValues: undefined,
    setEngraveFormValues: FunctionHelpers.emptyFn,
};

export const EngraveContext = createContext<EngraveContextValueType>(engraveContextInitialState);
export const useEngraveContext = () => useContext(EngraveContext);
